import type { ReactElement } from 'react'
import { Link, Outlet, createFileRoute, useLocation } from '@tanstack/react-router'

/**
 * Help Knowledge Base — the layout and its three tabs.
 *
 * The corpus the Kairos Assistant answers from. Three surfaces, one per thing an
 * admin actually does here: write and publish articles, manage the media those
 * articles embed, and read what people asked that nothing answered.
 *
 * The page title and the primary action live in the shell navbar
 * (`NAV_VARIANTS['/admin/help-kb']`), same as every other admin page.
 */
export const Route = createFileRoute('/admin/help-kb')({
  component: HelpKbLayout,
})

const TABS = [
  { to: '/admin/help-kb', label: 'Articles', exact: true },
  { to: '/admin/help-kb/media', label: 'Media', exact: false },
  { to: '/admin/help-kb/queries', label: 'Questions', exact: false },
] as const

function HelpKbLayout(): ReactElement {
  const { pathname } = useLocation()

  return (
    <div className="ka-page ka-page--help-kb">
      <div className="ka-tabs-bar" role="tablist" aria-label="Help Knowledge Base tabs">
        {TABS.map((tab) => {
          const active = tab.exact ? pathname === tab.to : pathname.startsWith(tab.to)
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={`ka-tab ${active ? 'is-active' : ''}`}
              role="tab"
              aria-selected={active}
            >
              {tab.label}
            </Link>
          )
        })}
      </div>

      <Outlet />
    </div>
  )
}
